import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Pagination from "../component/Pagination";
import { toast } from "react-toastify";


import {
  fetchCategories,
  createCategory,
  toggleCategoryStatus,
  toggleCategoryPopular,  
  deleteCategory,
  updateCategory
} from "../../../slice/category/categorySlice";


export default function ListCategory() {
  const [page, setPage] = useState(1);
  const limit = 10;
const IMAGE_BASE_URL = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();

  const { categories = [], loading, pagination = {} } = useSelector(
    (state) => state.category || {}
  );



  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [image, setImage] = useState(null);
  const [editImage, setEditImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editImagePreview, setEditImagePreview] = useState(null);
  const [currentCategoryImage, setCurrentCategoryImage] = useState(null);

  useEffect(() => {
    dispatch(fetchCategories({ page, limit }));
  }, [dispatch, page]);


const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

const validateImage = (file) => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Only JPG, PNG or WEBP images are allowed";
  }

  return null;
};

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const imageError = validateImage(file);
    if (imageError) {
      toast.error(imageError);
      return;
    }
    setImage(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  }
};

const handleEditImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const imageError = validateImage(file);
    if (imageError) {
      toast.error(imageError);
      return;
    }
    setEditImage(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setEditImagePreview(reader.result);
    };
    reader.readAsDataURL(file);
  }
};

const handleCreate = async () => {
  const trimmedName = name.trim();

  if (!trimmedName) {
    setErrorMsg("Category name is required");
    return;
  }

  if (trimmedName.length < 2) {
    setErrorMsg("Category name must be at least 2 characters");
    return;
  }

  if (!image) {
    setErrorMsg("Category image is required");
    return;
  }

  const imageError = validateImage(image);
  if (imageError) {
    toast.error(imageError);
    return;
  }

  setSubmitting(true);

  try {
    const formData = new FormData();
    formData.append("name", trimmedName);
    formData.append("status", true);
    formData.append("image", image);

    await dispatch(createCategory(formData)).unwrap();

    toast.success("Category added successfully");
    setShowModal(false);
    setName("");
    setImage(null);
    setImagePreview(null);
    dispatch(fetchCategories({ page, limit }));
  } catch {
    toast.error("Failed to add category");
  } finally {
    setSubmitting(false);
  }
};

const [deleteError, setDeleteError] = useState("");



const confirmDelete = async () => {
  if (!deleteId) return;

  try {
    await dispatch(deleteCategory(deleteId)).unwrap();

    toast.success("Category deleted successfully");
    setShowDeleteModal(false);
    setDeleteId(null);
    dispatch(fetchCategories({ page, limit }));

  } catch (err) {
  setDeleteError(err);
}

};


const handleUpdate = async () => {
  if (!editName.trim()) return;

  try {
    const formData = new FormData();
    formData.append("name", editName);

    if (editImage) {
      formData.append("image", editImage); // ✅ FILE
    }

    await dispatch(
      updateCategory({ id: editId, formData })
    ).unwrap();

    toast.success("Category updated successfully");
    setShowEditModal(false);
    setEditId(null);
    setEditName("");
    setEditImage(null);
    setEditImagePreview(null);
    setCurrentCategoryImage(null);
    dispatch(fetchCategories({ page, limit }));
  } catch {
    toast.error("Failed to update category");
  }
};




  return (
    <div className="row">


      <div className="card mt-3">



        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">Category Management</h4>
          <button className="btn cusBTNPop btn-sm" onClick={() => setShowModal(true)}>
            + Add Category
          </button>
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light">
              <tr>
                <th>SI</th>
                <th>Category Name</th>
                <th>image</th>
                <th>Status</th>
                  <th>Popular</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : categories.length > 0 ? (
                categories.map((cat, index) => (
                  <tr key={cat._id}>
                    <td>{index + 1}</td>
                    <td>{cat.name}</td>
                    <td>
                      {cat.image ? (
<img
  src={`${process.env.REACT_APP_API_URL}/uploads/${cat.image}`}
  alt=""
  width={40}
  height={40}
  style={{
    objectFit: "cover",
    borderRadius: "6px",
    backgroundColor: "#f1f1f1"
  }}
/>


                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      <div
                        className={`status-toggle ${cat.status ? "enabled" : "disabled"}`}
                        onClick={() => dispatch(toggleCategoryStatus(cat._id))}
                      >
                        <span className="toggle-knob"></span>
                        <span className="toggle-text">
                          {cat.status ? "Enabled" : "Disabled"}
                        </span>
                      </div>

                    </td>
                    <td>
  <div
    className={`status-toggle ${
      cat.isPopular ? "enabled" : "disabled"
    }`}
    onClick={() => dispatch(toggleCategoryPopular(cat._id))}
  >
    <span className="toggle-knob"></span>
    <span className="toggle-text">
      {cat.isPopular ? "Yes" : "No"}
    </span>
  </div>
</td>

                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={() => {
                            setEditId(cat._id);
                            setEditName(cat.name);
                            setCurrentCategoryImage(cat.image);
                            setEditImagePreview(null);
                            setShowEditModal(true);
                          }}
                        >
                          <iconify-icon icon="solar:pen-2-broken" />
                        </button>

                        <button
                          className="btn btn-soft-danger btn-sm"
                          onClick={() => {
                            setDeleteId(cat._id);
                            setShowDeleteModal(true);
                          }}
                        >
                          <iconify-icon icon="solar:trash-bin-minimalistic-2-broken" />
                        </button>


                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    No categories found
                  </td>
                </tr>
              )}
            </tbody>


          </table>
          <div className="card-footer border-top">
            <Pagination
              page={pagination.page}
              totalPages={pagination.totalPages}
              onPageChange={setPage}
            />

          </div>

        </div>

        {/* ADD CATEGORY MODAL */}
        {showModal && (


          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>


              <div className="modal-body">
                <div className="modal-header">
                  <h5>Add Category</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>
                <div className="modal-body">

                  <input
                    className={` form-control ${errorMsg ? "is-invalid" : ""}`}
                    placeholder="Enter category name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setErrorMsg("");
                    }}
                  />

                  {errorMsg && (
                    <div className="invalid-feedback d-block">
                      {errorMsg}
                    </div>
                  )}


                  <input
                    type="file"
                    className="form-control mt-3"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
     {errorMsg && (
                    <div className="invalid-feedback d-block">
                      {errorMsg}
                    </div>
                  )}

                  {imagePreview && (
                    <div className="mt-3 text-center">
                      <p className="mb-2 fw-semibold">Preview:</p>
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                          width: "150px",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ddd"
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    className="btn cusClose"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn cusBTNPop" onClick={handleCreate}>
                    Add Category
                  </button>
                </div>
              </div>


            </div>
          </div>
        )}

        {showDeleteModal && (
          <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>

              <div className="modal-header">
                <h5>Delete Category</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                />
              </div>

              <div className="modal-body">
                <p className="mb-0 text-center">
                  Are you sure you want to delete this category?
                </p>
              </div>
{deleteError && (
  <div className="error text-center">
    {deleteError}
  </div>
)}

              <div className="modal-footer">
              <button
  className="btn cusClose"
  onClick={() => {
    setShowDeleteModal(false);
    setDeleteError("");
  }}
>
  Cancel
</button>

                <button
                  className="btn cuscancel"
                  onClick={confirmDelete}
                >
                  Delete
                </button>
              </div>

            </div>
          </div>
        )}


        {showEditModal && (
          <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>

              <div className="modal-header">
                <h5>Edit Category</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                />
              </div>

              <div className="modal-body">
                <label className="form-label">Category Name</label>
                <input
                  className="form-control"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                />
             
                <label className="form-label mt-3">Upload Images</label>
                <input
                  type="file"
                  className="form-control mt-1"
                  accept="image/*"
                  onChange={handleEditImageChange}
                />

                {(editImagePreview || currentCategoryImage) && (
                  <div className="mt-3 text-center">
                    <p className="mb-2 fw-semibold">
                      {editImagePreview ? "New Image Preview:" : "Current Image:"}
                    </p>
                    <img
                      src={
                        editImagePreview ||
                        `${process.env.REACT_APP_API_URL}/uploads/${currentCategoryImage}`
                      }
                      alt="Category"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd"
                      }}
                    />
                  </div>
                )}
              </div>


              <div className="modal-footer">
                <button
                  className="btn cusClose"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn cusBTNPop"
                  onClick={handleUpdate}
                >
                  Update
                </button>
              </div>

            </div>
          </div>
        )}


      </div>
    </div>
  );
}